import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeAnalyticsAudience.graphql';
import { Query, QueryinfluencerYoutubeAnalyticsAudienceArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeAnalyticsAudienceQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeAnalyticsAudienceLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>
): QueryResult<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs> & {
  getInfluencerYoutubeAnalyticsAudience: LazyQueryExecFunction<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeAnalyticsAudience, result] = useLazyQuery<
    Query,
    QueryinfluencerYoutubeAnalyticsAudienceArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerYoutubeAnalyticsAudience, ...result };
};

export const useInfluencerYoutubeAnalyticsAudiencePromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeAnalyticsAudience = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeAnalyticsAudienceArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeAnalyticsAudience };
};
// Suspense Query Hooks
export const useInfluencerYoutubeAnalyticsAudienceSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeAnalyticsAudienceArgs>(QUERY, {
    ...options
  });

  return result;
};
